export const CONFIG = {
  width: 900,
  height: 620,
  hudHeight: 56,

  /** Sites each player places before the game ends. */
  sitesPerPlayer: 8,

  /** Reject clicks this close to an existing site (pixels). */
  minSiteDistance: 26,

  /** Candidate points the AI samples each turn when picking a move. */
  aiSamples: 220,

  players: [
    { name: 'You', fill: '#3b82f6', accent: '#bfdbfe', human: true },
    { name: 'AI', fill: '#ef4444', accent: '#fecaca', human: false },
  ],
};
